import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createAxiosWarehouse, warehouseApiRequest } from "../utils/request";
import { warehouseApis } from "../utils/apis";
import { getUsers } from "../utils/getUser";
import axios from "axios";

export const createInboundShipment = createAsyncThunk(
  "createInboundShipment",
  async (payload) => {
    try {
      const axiosInstance = createAxiosWarehouse();
      const response = await axiosInstance.post(
        warehouseApis.createInboundShipment,
        payload
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const listAllItemsByTrackingId = createAsyncThunk(
  "listAllItemsByTrackingId",
  async (payload) => {
    try {
      const axiosInstance = createAxiosWarehouse();
      const response = await axiosInstance.get(
        `${warehouseApis.listAllItemsByTrackingNumber}/${payload}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const listAllTrackingIds = createAsyncThunk(
  "listAllTrackingIds",
  async () => {
    try {
      const axiosInstance = createAxiosWarehouse();
      const response = await axiosInstance.get(
        warehouseApis.listAllTrackingNumbers
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getInboundShipmentLogs = createAsyncThunk(
  "getInboundShipmentLogs",
  async (payload) => {
    try {
      const axiosInstance = createAxiosWarehouse();
      const response = await axiosInstance.get(
        `${warehouseApis.getInboundShipmentLogs}/${payload}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const listAllInventoryItems = createAsyncThunk(
  "listAllInventoryItems",
  async () => {
    try {
      const axiosInstance = createAxiosWarehouse();
      const response = await axiosInstance.get(
        warehouseApis.listAllInventoryItems
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getInventoryLogs = createAsyncThunk(
  "getInventoryLogs",
  async (payload) => {
    try {
      const axiosInstance = createAxiosWarehouse();
      const response = await axiosInstance.get(
        `${warehouseApis.getInventoryLogs}?upc=${payload}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const downloadShipmentImage = createAsyncThunk(  
  "downloadShipmentImage",
  async (payload) => {
    try {
      const axiosInstance = createAxiosWarehouse();
      const response = await axiosInstance.get(
        `${warehouseApis.downloadInboundShipmentImage}?id=${payload}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const uploadInboundShipmentImage = createAsyncThunk(
  "uploadInboundShipmentImage",
  async ({ formData, id }) => {
    try {
      const axiosInstance = createAxiosWarehouse();
      const response = await axiosInstance.post(
        `${warehouseApis.uploadInboundShipmentImage}?id=${id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${getUsers()?.access_token}`,
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "DELETE, POST, GET, OPTIONS",
            "Access-Control-Allow-Headers":
              "Content-Type, Access-Control-Allow-Headers, Authorization, X-Requested-With",
            Accept: "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

export const getShipmentSummary = createAsyncThunk(
  "getShipmentSummary",
  async (payload) => {
    try {
      const axiosInstance = createAxiosWarehouse();
      const response = await axiosInstance.get(
        `${warehouseApis.getShipmentSummary}/${payload}`
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.status === 401) {
        localStorage.clear();
        window.location.replace("/");
      } else {
        throw new Error(error.response?.data?.detail || error.message);
      }
    }
  }
);

const WarehouseSlice = createSlice({
  name: "warehouse",
  initialState: {
    orderSlice: {},
  },
  extraReducers: (builder) => {
    builder
      .addCase(createInboundShipment.pending, (state) => {
        state.loading = true;
      })
      .addCase(createInboundShipment.fulfilled, (state, action) => {
        state.loading = false;
        state.shipmentSlice = action.payload;
      })
      .addCase(createInboundShipment.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export default WarehouseSlice.reducer;
